module.exports = __webpack_public_path__ + "img/meta_thumbnail.4667c481.png";